module.exports = __webpack_public_path__ + "static/media/galerija_2019 (22).4b346c44.jpg";